export default __webpack_public_path__ + "static/media/cont10.0b16bff3.png";